<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-dialog v-model="dialog" max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="indigo"
                            class="white--text"
                            v-on="on"
                            @click="newTax"
                        >
                            <v-icon left>mdi-currency-usd-off</v-icon>
                            Adicionar Taxa
                        </v-btn>
                    </template>
                    <form @submit.prevent="saveTax">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Adicionar Taxa</span>
                            </v-card-title>
                            <v-card-text v-if="tax">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-currency-field
                                                label="Taxa"
                                                v-bind="$t('percent-config')"
                                                v-model="tax.value"
                                                :error-messages="valueErrors"
                                                @input="$v.tax.value.$touch()"
                                                @blur="$v.tax.value.$touch()"
                                            ></v-currency-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="grey"
                                    @click="dialog = false"
                                    text
                                >
                                    Fechar
                                </v-btn>

                                <v-btn color="success" type="submit">
                                    <v-icon left small>mdi-check</v-icon>
                                    {{ $t('form.actions.save') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </form>
                </v-dialog>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table" :headers="headers">
                    <template #value="{ item }">
                        {{ item.formattedValue }}
                    </template>

                    <template #user="{ item }">
                        {{ item.createdUserName }}
                    </template>

                    <template #created="{ item }">
                        {{ item.formattedCreatedAt }}
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Tax from '@/models/Tax'
import { required, between } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        'sarala-table': SaralaTable,
    },

    data: () => {
        return {
            dialog: false,
            tax: null,
        }
    },

    mixins: [validationMixin],

    validations: {
        tax: {
            value: { required, between: between(0.01, 99.99) },
        },
    },

    computed: {
        model() {
            return new Tax()
        },

        headers() {
            return [
                { text: 'Taxa', value: 'value', sortable: false },
                { text: 'Criado por', value: 'user', sortable: false },
                { text: 'Criado em', value: 'created', sortable: false },
            ]
        },

        valueErrors() {
            const errors = []

            if (!this.$v.tax.value.$dirty) return errors

            !this.$v.tax.value.required &&
                errors.push('Este campo é obrigatório')

            !this.$v.tax.value.between &&
                errors.push('O valor deve ser entre 0.01 e 99.99')

            return errors
        },
    },

    methods: {
        newTax() {
            if (!this.tax) {
                this.tax = new Tax()
            }
        },

        async saveTax() {
            await this.tax.save()

            this.tax = null
            this.dialog = false

            this.$refs.table.getItems()
        },
    },
}
</script>
